import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, ActivatedRoute, Router } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatListModule } from '@angular/material/list';
import { MatDividerModule } from '@angular/material/divider';
import { MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBarModule, MatSnackBar } from '@angular/material/snack-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { BookingService } from '../../../core/api/booking.service';
import { Booking, BookingStatus } from '../../../core/models/booking.model';
import { StatusLabelPipe } from '../../../shared/pipes/status-label.pipe';
import { formatDateTime } from '../../../shared/utils/date.utils';
import { BookingDeleteDialogComponent } from '../booking-delete-dialog/booking-delete-dialog.component';
import { CopyTextComponent } from '../../../shared/components/copy-text/copy-text.component';

@Component({
  selector: 'app-booking-detail',
  standalone: true,
  imports: [CommonModule, RouterModule, MatCardModule, MatIconModule, MatButtonModule, MatChipsModule, MatListModule, MatDividerModule, MatDialogModule, MatSnackBarModule, MatProgressSpinnerModule, StatusLabelPipe, CopyTextComponent],
  templateUrl: './booking-detail.component.html',
  styleUrl: './booking-detail.component.scss',
})
export class BookingDetailComponent implements OnInit {
  loading = true;
  booking: Booking | null = null;
  BookingStatus = BookingStatus;
  formatDateTime = formatDateTime;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private bookingService: BookingService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
  ) {}

  ngOnInit(): void {
    const id = Number(this.route.snapshot.paramMap.get('id'));
    if (!id) return;
    this.bookingService.get(id).subscribe({
      next: (b) => { this.booking = b; this.loading = false; },
      error: () => { this.loading = false; },
    });
  }

  confirmBooking(): void {
    if (!this.booking) return;
    this.bookingService.confirm(this.booking.id).subscribe({
      next: (b) => { this.booking = b; this.snackBar.open('Бронирование подтверждено', 'ОК', { duration: 3000 }); },
      error: () => { this.snackBar.open('Ошибка', 'ОК', { duration: 3000 }); },
    });
  }

  cancelBooking(): void {
    if (!this.booking) return;
    this.bookingService.cancel(this.booking.id).subscribe({
      next: (b) => { this.booking = b; this.snackBar.open('Бронирование отменено', 'ОК', { duration: 3000 }); },
      error: () => { this.snackBar.open('Ошибка', 'ОК', { duration: 3000 }); },
    });
  }

  completeBooking(): void {
    if (!this.booking) return;
    this.bookingService.complete(this.booking.id).subscribe({
      next: (b) => { this.booking = b; this.snackBar.open('Бронирование завершено', 'ОК', { duration: 3000 }); },
      error: () => { this.snackBar.open('Ошибка', 'ОК', { duration: 3000 }); },
    });
  }

  deleteBooking(): void {
    if (!this.booking) return;
    const ref: MatDialogRef<BookingDeleteDialogComponent, boolean> = this.dialog.open(
      BookingDeleteDialogComponent,
      { data: { booking: this.booking }, width: '420px' },
    );
    ref.afterClosed().subscribe((confirmed) => {
      if (!confirmed) return;
      this.bookingService.delete(this.booking!.id).subscribe({
        next: () => {
          this.snackBar.open('Бронирование удалено', 'ОК', { duration: 3000 });
          this.router.navigate(['/bookings']);
        },
        error: () => {
          this.snackBar.open('Не удалось удалить бронирование', 'ОК', { duration: 5000 });
        },
      });
    });
  }
}